<template>
  <div>
    <v-col>
      <ScreeningCatalogueAnalysisRequest
        :standalone="false"
        :disabled="workInProgress"
        v-on:initSaveFunction="saveFunction = $event"
        v-on:updateValid="inputsValid = $event"
        v-on:updateSaving="inputsSaving = $event"
        v-on:updateRequestId="requestId = $event"
      />
      <v-row class="d-flex justify-center align-space-around">
        <v-btn
          color="primary"
          class="ma-2"
          @click="saveFunction()"
          :disabled="!inputsValid || inputsSaving || workInProgress"
          :loading="inputsSaving || workInProgress"
          >Save current parameters
        </v-btn>
        <template v-if="displayDashboard && verificationNoAlersDelete">
          <progress-dialog
            class="ma-2"
            :callbackStatus="() => {}"
            :computing.sync="computing"
            :workInProgress.sync="workInProgress"
            :text="'Compute results'"
            :button-color="'primary'"
            :visibility="displayComputationWidget && !inputsSaving"
          ></progress-dialog>
          <v-tooltip bottom v-if="!displayComputationWidget || inputsSaving">
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on">
                <v-btn
                  class="ma-2"
                  :loading="inputsSaving || workInProgress"
                  :disabled="true"
                  color="primary"
                  >Compute results</v-btn
                >
              </div>
            </template>
            <span
              >Alerts and data inputs have not changed since last computation
            </span>
          </v-tooltip>
        </template>
      </v-row>
      <ScreeningCatalogueAnalysisDashboard
        v-if="displayDashboard && !inputsSaving"
        class="mt-6"
        :standalone="false"
        v-on:initComputeFunction="computeFunction = $event"
      />
    </v-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import errorMixin from '../../mixins/logHandler.js'
import ScreeningCatalogueAnalysisRequest from './ScreeningCatalogueAnalysisRequest'
import ScreeningCatalogueAnalysisDashboard from './ScreeningCatalogueAnalysisDashboard'
import ProgressDialog from '../../components/Dashboard/ProgressDialog'

export default {
  name: 'ScreeningCatalogueAnalysisReactiveDashboard',
  mixins: [errorMixin],
  data() {
    return {
      saveFunction: () => {},
      inputsValid: false,
      inputsSaving: false,
      requestId: 'NoID',
      computing: false,
      workInProgress: false
    }
  },
  components: {
    ScreeningCatalogueAnalysisRequest,
    ScreeningCatalogueAnalysisDashboard,
    ProgressDialog
  },

  watch: {},

  mounted() {},

  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      currentMission: 'currentMission',
      currentResultsLog: 'currentResultsLog'
    }),
    displayComputationWidget() {
      return this.computationNeeded || !this.resultsLoaded
    },
    computationNeeded() {
      return (
        this.currentMission &&
        this.currentMission.computationRequested &&
        this.currentMission.computationLogId === ''
      )
    },
    resultsLoaded() {
      return (
        this.currentResultsLog != null && this.currentResultsLog.results != null
      )
    },
    isMissionLoaded() {
      return this.currentMission?.id === this.requestId
    },
    isMissionTemp() {
      return this.currentMission?.name === ''
    },
    verificationNoAlersDelete() {
      let isValid = true
      for (const alert of this.currentMission.analysisRequest
        .alertDefinitions) {
        if (alert == null) {
          isValid = false
        }
      }
      return isValid
    },
    displayDashboard() {
      return this.isMissionLoaded && !this.isMissionTemp
    }
  },

  methods: {}
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto');
</style>
